module.exports = __webpack_public_path__ + "static/media/chaos-dashboard.c6845f84.png";